var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2108 33.3497L62.2104 33.3506C58.8073 40.8442 54.5837 46.3687 49.5843 50.0199C44.6011 53.6591 38.7623 55.5 32 55.5C25.2414 55.5 19.4025 53.6592 14.4182 50.0206C9.41797 46.3705 5.19286 40.8482 1.79004 33.3593C1.59983 32.9379 1.5 32.4748 1.5 32.0038C1.5 31.5328 1.59984 31.0697 1.79009 30.6483C5.19306 23.1553 9.41646 17.6311 14.4157 13.9801C19.3989 10.3409 25.2376 8.5 32 8.5C38.7585 8.5 44.5974 10.3408 49.5818 13.9794C54.5812 17.6289 58.8057 23.15 62.2082 30.637C62.5994 31.5157 62.5942 32.5068 62.2108 33.3497Z",
    fill: "url(#paint0_linear_42_13513)",
    stroke: "url(#paint1_linear_42_13513)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 32C46 39.732 39.732 46 32 46C24.268 46 18 39.732 18 32C18 24.268 24.268 18 32 18C39.732 18 46 24.268 46 32ZM49 32C49 41.3888 41.3888 49 32 49C22.6112 49 15 41.3888 15 32C15 22.6112 22.6112 15 32 15C41.3888 15 49 22.6112 49 32ZM40.0607 29.0607C40.6464 28.4749 40.6464 27.5251 40.0607 26.9393C39.4749 26.3536 38.5251 26.3536 37.9393 26.9393L31 33.8787L27.0607 29.9393C26.4749 29.3536 25.5251 29.3536 24.9393 29.9393C24.3536 30.5251 24.3536 31.4749 24.9393 32.0607L29.9393 37.0607C30.5251 37.6464 31.4749 37.6464 32.0607 37.0607L40.0607 29.0607Z",
    fill: "url(#paint2_linear_42_13513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_13513",
    x1: 56.96,
    y1: 7,
    x2: -0.302474,
    y2: 39.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_13513",
    x1: 13.8182,
    y1: 11.4118,
    x2: 33.5286,
    y2: 60.4673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_13513",
    x1: 22.14,
    y1: 15,
    x2: 18.7925,
    y2: 47.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeChecked);
export default __webpack_public_path__ + "static/media/eye-checked.d7b04c963da423ba6c8b6885b8cc4454.svg";
export { ForwardRef as ReactComponent };